export const SYSTEM_GET_ALL_REQUESTED = "SYSTEM_GET_ALL_REQUESTED";
export const SYSTEM_GET_ALL_SUCCEEDED = "SYSTEM_GET_ALL_SUCCEEDED";
export const SYSTEM_GET_ALL_FAILED = "SYSTEM_GET_ALL_FAILED";